import { atom } from 'recoil';

export const inputTextState = atom<string>({
  key: 'inputTextState',
  default: '',
});

// export const itemsLength = selector<number>({
//   key: 'itemsLength',
//   get: ({ get }) => {
//     const itemNumber: Array<Items> = get(itemsState);
//     return itemNumber?.length || 0;
//   },
// });
